import React from 'react';

import { CheckIcon, InfoIcon } from 'components/Icons';

import styles from './Notification.module.scss';

export enum NotificationType {
  Success = 'Success',
  Failure = 'Failure',
}

export interface NotificationProps {
  message: string | JSX.Element;
  type: NotificationType;
  isIcon?: boolean;
  textProveFailure?: boolean;
}

const iconByTypeMap = new Map<NotificationType, JSX.Element>([
  [NotificationType.Success, <CheckIcon className={styles.checkIcon} />],
  [NotificationType.Failure, <InfoIcon iconClassName={styles.infoIcon} />],
]);

const Notification = ({ message, type, isIcon = true, textProveFailure = false }: NotificationProps) => {
  return (
    <div className={styles.notificationContainer}>
      {isIcon ? <div>{iconByTypeMap.get(type)}</div> : ''}
      <div className={textProveFailure ? styles.textProveFailure : styles.text}>{message}</div>
    </div>
  );
};

export default Notification;
